import { Icon3d3d, Icon3dAlert, Icon3dCycle, Icon3dDetect, Icon3dLocation, Icon3dMeter } from '@assets/images/icon';
import { accessAutoThumb, deadboltThumb, emlockThumb } from '@assets/images/main/access/product';
import { IconAoaOff, IconAoaOn, IconComfortOff, IconComfortOn, IconOsOff, IconOsOn, IconTwintrackerOff, IconTwintrackerOn } from '@assets/images/main/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';
import {
  rtlsScreenshot1D,
  rtlsScreenshot1T,
  rtlsScreenshot1M,
  rtlsScreenshot2D,
  rtlsScreenshot2T,
  rtlsScreenshot2M,
  rtlsScreenshot3D,
  rtlsScreenshot3T,
  rtlsScreenshot3M,
  rtlsScreenshot4D,
  rtlsScreenshot4T,
  rtlsScreenshot4M,
  accessKey1,
  accessKey2,
  accessKey3,
  accessKey4,
  accessOutlook,
  IconBox,
  IconComputer,
  IconGuarantee,
  assetOn,
  workerOn,
  workerOff,
  IconPath,
  IconLocation,
  IconAnalyze,
  IconAlarm,
  IconExcel,
  IconSDK,
  assetOff,
} from '@assets/images/main/index';
import {
  RtlsFunctions1D,
  RtlsFunctions1M,
  RtlsFunctions1T,
  RtlsFunctions2D,
  RtlsFunctions2M,
  RtlsFunctions2T,
  RtlsFunctions3D,
  RtlsFunctions3M,
  RtlsFunctions3T,
  RtlsFunctions4D,
  RtlsFunctions4M,
  RtlsFunctions4T,
  RtlsFunctions5D,
  RtlsFunctions5M,
  RtlsFunctions5T,
} from '@assets/images/main/rtls/main/functions';
import {
  RtlsHardware1D,
  RtlsHardware1M,
  RtlsHardware1T,
  RtlsHardware2D,
  RtlsHardware2M,
  RtlsHardware2T,
  RtlsHardware3D,
  RtlsHardware3M,
  RtlsHardware3T,
  RtlsHardware4D,
  RtlsHardware4M,
  RtlsHardware4T,
} from '@assets/images/main/rtls/main/hardware';
import { assetTag, twinTracker1, twinTrackerBracket } from '@assets/images/main/rtls/product';

export default {
  banner: {
    title: '屋内位置追跡<br/>よりシンプルに。より正確に。',
    desc: '固定型から携帯型まで、<br/>空間の制約なく適用可能な高精度位置追跡技術を体験してください。',
    schemeTitle: 'あなたに合った位置測位を選択してください。',
    schemeDesc: '決定するのにお手伝いが必要ですか？ ',
    schemeDesc2: 'までお問い合わせください。<br/>専門の専門家がお手伝いいたします。',
    phone: '(+82)1522-9928',
    card: [
      {
        title: '国内唯一',
        desc: '位置追跡に適用<br/>ネットワークデバイスの製造',
      },
      {
        title: '50億以上の記録',
        desc: 'アジア最大のスケール<br/>リアルタイムの位置情報データ',
      },
      {
        title: '世界クラスのパフォーマンス',
        desc: 'AIアルゴリズムを使用した<br/>最高水準の位置精度',
      },
    ],
  },

  mainPage: {
    product: {
      title: '製品構成を確認する',
      desc: '革新的な位置測位製品構成を確認してください。',
      asset: {
        title: 'Bluetooth(BLE)位置測位',
        desc: '説明：「BLEタグデバイスを対象物に取り付けて、資産として監視または追跡し、リアルタイムの位置追跡が可能です。',
      },
      worker: {
        title: '高精度UWB位置追跡',
        desc: '説明：「UWBタグデバイスを対象物に取り付けて、資産として監視または追跡し、リアルタイムの位置追跡が可能です。',
      },
    },
  },

  screenShot: [
    {
      title: '現場全体を地図上に可視化',
      desc: 'BLE/UWB/AoA に基づいた位置情報が建物の図面やエリアマップ上にリアルタイムで表示されます。<br/>階層ビュー、エリアフィルター、ステータスアイコンにより、視覚的な管理が容易になります。',
      img: {
        desktop: rtlsScreenshot1D,
        tablet: rtlsScreenshot1T,
        mobile: rtlsScreenshot1M,
      },
    },
    {
      title: '過去の動きを今のように再生',
      desc: '人や資産の移動履歴をタイムラインに基づいて記録・再生できます。<br/>特定の時間帯を選択して、個人または複数対象の動線を比較したり、異常を振り返ったりできます。',
      img: {
        desktop: rtlsScreenshot2D,
        tablet: rtlsScreenshot2T,
        mobile: rtlsScreenshot2M,
      },
    },
    {
      title: 'よく動いたエリアを一目で確認',
      desc: '時間帯別の移動量を可視化するヒートマップ機能を提供。<br/>作業者の集中エリア、非効率な動線、放置された空間などを分析し、レイアウト改善や人員配置の最適化に役立てられます。',
      img: {
        desktop: rtlsScreenshot3D,
        tablet: rtlsScreenshot3T,
        mobile: rtlsScreenshot3M,
      },
    },
    {
      title: '定義されたゾーンに入ると即時反応',
      desc: 'ORBRO OS では、マップ上にゾーンを自由に定義できます。<br/>指定した人や資産がゾーンに出入りすると、即座にアラートが発生します。<br/>このアラートは API を通じて外部システムと柔軟に連携可能です。',
      img: {
        desktop: rtlsScreenshot4D,
        tablet: rtlsScreenshot4T,
        mobile: rtlsScreenshot4M,
      },
    },
  ],
  video: {
    title: 'ORBRO位置測位システム',
    desc: [
      { text: 'ダッシュボード機能を通じて機器の状態、タグ端末の変動推移カテゴリ別分類現況、区域別現況を<br/>一目で素早く確認することができます。' },
      { text: 'デバイスを基準に、対象の位置と現状をすばやく把握できます。<br />正確なデータと簡単なインターフェースを提供します。' },
      { text: '作業空間から危険区域まで素早く設定でき、<br/>区域別現況を素早く把握できます。' },
      { text: '危険区域に進入する場合をはじめ、<br/>様々な状況に適したアラームを素早く送信できます。' },
    ],
  },

  functions: {
    title: '革新的な位置追跡システムの体験',
    desc: 'Orbroの位置追跡システムは、ウェブベースの管理およびモバイルアプリを提供することで、既存の位置追跡システムの中で最高のユーザーコンビニエンスを提供します。',

    line: 2,
    card: [
      {
        size: '3',
        tag: '統合管理ソフトウェア',
        title: '屋内マップに基づいたソフトウェア',
        label: '管理者',
        img: {
          desktop: RtlsFunctions1D,
          tablet: RtlsFunctions1T,
          mobile: RtlsFunctions1M,
        },
      },
      {
        size: '1',
        tag: 'モバイルアプリ提供',
        title: 'モバイルアプリを介した位置追跡',
        label: '共通提供',
        img: {
          desktop: RtlsFunctions2D,
          tablet: RtlsFunctions2T,
          mobile: RtlsFunctions2M,
        },
      },
      {
        size: '2',
        tag: 'デバイス履歴管理',
        title: 'ゾーンごとのデバイスの位置のリアルタイム記録',
        label: '管理者',
        img: {
          desktop: RtlsFunctions3D,
          tablet: RtlsFunctions3T,
          mobile: RtlsFunctions3M,
        },
      },
      {
        size: '2',
        tag: 'ゾーン設定',
        title: 'ゾーンごとのデバイスのリアルタイム追跡',
        label: '管理者',
        img: {
          desktop: RtlsFunctions4D,
          tablet: RtlsFunctions4T,
          mobile: RtlsFunctions4M,
        },
      },
      {
        size: '2',
        tag: 'デバイス管理',
        title: '便利なデバイス管理',
        label: '管理者',
        img: {
          desktop: RtlsFunctions5D,
          tablet: RtlsFunctions5T,
          mobile: RtlsFunctions5M,
        },
      },
    ],
  },

  hardware: {
    title: 'コアはハードウェア、すべてが軽やかに革新',
    desc: '当社の位置追跡システムのデバイスは、指向性アンテナと現場の環境を考慮したデザインが施された特別製のデバイスです。最適な性能と安定性を実現するために、指向性アンテナを適用し、さまざまな状況で効果的に動作します。',
    card: [
      {
        img: {
          desktop: RtlsHardware1D,
          tablet: RtlsHardware1T,
          mobile: RtlsHardware1M,
        },
        tag: '指向性アンテナ',
        title: '指向性アンテナによる正確な位置追跡',
        desc: 'TwinTracker（位置追跡デバイス）の指向性アンテナは、無線信号の方向を推測できます。',
      },
      {
        img: {
          desktop: RtlsHardware2D,
          tablet: RtlsHardware2T,
          mobile: RtlsHardware2M,
        },
        tag: 'さまざまなブラケット',
        title: '天井埋め込み型、レイ設置可能',
        falldown: [
          {
            title: '天井埋め込みブラケット',
            desc: '石膏、テクス、SMC、マイトンなど<br/>さまざまな天井に取り付け可能。',
          },
          {
            title: 'レール型ブラケット',
            desc: '照明に使用されるレールと同じ規格で<br/>天井にレールが取り付けられていればいつでも取り付け可能です。',
          },
        ],
      },
      {
        img: {
          desktop: RtlsHardware3D,
          tablet: RtlsHardware3T,
          mobile: RtlsHardware3M,
        },
        tag: '革新的な技術',
        title: 'TDoA技術を活用した最小の設置、最大のパフォーマンス',
        desc: 'TDoA技術は、高性能な通信を維持しながらバッテリーの消費を革新的に低減させた通信技術です。リアルタイムで動作しながらも、位置の精度は従来よりもはるかに高い数値を記録します。',
      },
      {
        img: {
          desktop: RtlsHardware4D,
          tablet: RtlsHardware4T,
          mobile: RtlsHardware4M,
        },
        tag: 'さまざまな通信方式',
        title: '有線通信、無線通信、両方が接続可能',
      },
    ],
  },
  faqRequest: 'いつでもお気軽に',
  faqRequestTail: 'お問い合わせください。',
  FAQ: [
    {
      title: '技術の知識がなくても使えますか？',
      description:
        'ORBRO システムは、技術知識がなくても使えるように、シンプルかつ強力なインターフェースを提供します。<br/>可視化されたデータにより、直感的に分析・操作できます。',
    },
    {
      title: '位置測位の精度はどのくらいですか？',
      description: 'ORBRO RTLS システムは非常に高精度です。<br/>リアルタイム性を重視しており、誤差がほとんどなく高速なデータ連携が可能です。',
    },
    {
      title: '位置測位以外の機能も使いたいのですが？',
      description: 'ORBRO の技術は高い拡張性を持っています。<br/>位置測位に加えて、動線分析、ルート逸脱、立入禁止ゾーン設定など様々な機能が利用可能です。',
    },
    {
      title: 'ORBRO の位置追跡システムはどう動作しますか？',
      description:
        'ORBRO は BLE、UWB、AoA などの無線技術を使用し、タグから送信された信号をアンカーが受信して位置を算出します。<br/>算出された位置情報は、ORBRO OS の地図画面やスマホアプリでリアルタイムに確認できます。',
    },
    {
      title: 'TwinTracker BLE、UWB、AoA の違いは？',
      description:
        'BLE：低電力・簡単設置・約1〜3m精度<br/>UWB：高精度（10〜30cm）・高速応答・複雑環境に最適<br/>AoA：BLE信号の到達角を用いた測位・屋内動線分析に有利',
    },
    {
      title: 'Comfort Kit は ORBRO システムと連携できますか？',
      description:
        'Comfort Kit はスマートフォンアプリで使用できるスタンドアロン型製品です。<br/>ORBRO OS やサーバーなしでも、リアルタイム位置情報を取得できます。',
    },
    {
      title: 'ORBRO OS はどのような環境で使用しますか？',
      description:
        'ORBRO OS は ORBRO Server または Edge が設置された環境で使用します。<br/>位置追跡、イベントモニタリング、履歴分析などを提供し、<br/>地図ベースの UI により管理者・運営者が直感的に使用可能です。',
    },
    {
      title: '位置情報を外部システムで使えますか？',
      description: 'はい、ORBRO は API を提供しており、<br/>スマート工場やセキュリティシステムなど外部と柔軟に連携可能です。',
    },
    {
      title: '一つの現場で複数の製品を使えますか？',
      description: 'はい、可能です。<br/>BLE、UWB、AoA を組み合わせて一つのプラットフォーム上で運用でき、<br/>複雑な環境に最適な構成が可能です。',
    },
    {
      title: '屋内外どちらも追跡できますか？',
      description: 'はい。屋内は BLE/UWB/AoA、<br/>屋外は GPS を組み合わせたハイブリッド構成で運用できます。',
    },
    {
      title: '同時に何個のタグを使えますか？',
      description: 'システム構成とサーバー性能によって、数十から数千まで対応可能です。<br/>ORBRO は大規模環境でも安定したトラッキング性能を発揮します。',
    },
    {
      title: '設置や保守は難しいですか？',
      description:
        'ORBRO は設計から施工・試運転まで全てをサポートします。<br/>多くのデバイスは遠隔監視やファームウェア更新に対応しており、<br/>保守も電池交換と定期点検だけで十分です。',
    },
    {
      title: '位置情報はどのように確認しますか？',
      description:
        'ORBRO OS の地図画面で可視化されたデータを確認できます。<br/>スマホアプリでも同じデータをリアルタイムで確認可能です。<br/>また API によって外部システムとの連携も可能です。',
    },
  ],

  bannerData: [
    {
      icon: IconTwintrackerOn,
      iconInv: IconTwintrackerOff,
      image: '',
      iconText: 'TwinTracker UWB',
      sub: 'New',
      link: '/jp/rtls/uwb',
    },
    {
      icon: IconAoaOn,
      iconInv: IconAoaOff,
      image: '',
      iconText: 'TwinTracker AoA',
      sub: 'New',
      link: '/jp/rtls/aoa',
    },
    {
      icon: IconTwintrackerOn,
      iconInv: IconTwintrackerOff,
      image: '',
      iconText: 'TwinTracker BLE',
      sub: 'New',
      link: '/jp/rtls/ble',
    },
    {
      icon: IconComfortOn,
      iconInv: IconComfortOff,
      image: '',
      iconText: 'Comfort Kit',
      sub: 'New',
      link: '/jp/rtls/comfort',
    },
  ],

  product: {
    asset: {
      func: 'バッテリー内蔵の製品で、電源工事は必要ありません。出入り口の近くに取り付けて、モバイルで簡単かつ迅速に出入り制御ができます。',
      key1: accessKey1,
      key2: accessKey2,
      key3: accessKey3,
      key4: accessKey4,
      outlook: accessOutlook,
    },
  },

  purchaseDesc: {
    asset: '説明：「BLEタグデバイスを対象物に取り付けて、資産として監視または追跡し、リアルタイムの位置追跡が可能です。',
    worker: '説明：「UWBタグデバイスを対象物に取り付けて、資産として監視または追跡し、リアルタイムの位置追跡が可能です。',
  },

  purchase: {
    //모바일
    asset: {
      assetTracking: {
        icon: accessKey1,
        title: '資産位置測位',
        serial: 'Asset-Tracking',
        price: '5,900,000',

        note: [
          { text: 'TwinTracker (BLE) 10台', icon: IconBox },
          { text: '資産測位タグ 30台', icon: IconBox },
          { text: 'Server PC 1台', icon: IconComputer },
          { text: '3年間の保証期間', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Asset Tag(BLE)',
            price: '30,000',
            img: assetTag,
          },
          {
            title: 'TwinTracker(BLE)',
            price: '300,000',
            img: twinTracker1,
          },
          {
            title: 'TwinTracker Bracket',
            price: '100,000',
            img: twinTrackerBracket,
          },
        ],
        mark: '',
      },
    },

    //자동문 출입
    worker: {
      workerTracking: {
        icon: accessKey1,
        title: '作業者位置測位',
        serial: 'Worker-Tracking',
        price: '5,000,000',

        note: [
          { text: 'TwinTracker (UWB) 10台', icon: IconBox },
          { text: '作業者測位タグ 10台', icon: IconBox },
          { text: 'Server PC 1台', icon: IconComputer },
          { text: '3年間の保証期間', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Tag(UWB)',
            price: '60,000',
            img: emlockThumb,
          },
          {
            title: 'TwinTracker(UWB)',
            price: '300,000',
            img: deadboltThumb,
          },
          {
            title: 'TwinTracker Bracket',
            price: '100,000',
            img: accessAutoThumb,
          },
        ],
        mark: '',
      },
    },
  },

  func: {
    title: '機能をもっと見る',
    desc: '位置追跡のさまざまな機能をご確認ください。',

    data: [
      {
        img: IconBlueShield,
        title: '権限・グループ管理',
        desc: '管理者・ユーザーごとに機能へのアクセスを制御し、部署やチーム単位でグループを構成できます。',
      },
      {
        img: IconAlarm,
        title: '条件通知設定（5段階）',
        desc: '設定条件に応じて最大5段階のアラートを設定でき、異常を素早く検出・対応できます。',
      },
      {
        img: Icon3dMeter,
        title: 'エリアモニタリング（Zone）',
        desc: 'マップ上にゾーンを設定し、その区域に入った人物や資産をリアルタイムで監視できます。',
      },
      {
        img: Icon3dCycle,
        title: '逆走検出',
        desc: '移動ルートと逆方向の動きをシステムが自動で検出し、警告を発します。',
      },
      {
        img: Icon3dLocation,
        title: 'カテゴリ別追跡管理',
        desc: 'タグ端末を人物、資産、車両などに分類し、効率的なデータ管理と分析が可能です。',
      },
      {
        img: Icon3dAlert,
        title: '長時間未検出タグ通知',
        desc: '一定時間内に検出されないタグについては、自動的に管理者へ通知を送信します。',
      },
      {
        img: Icon3dDetect,
        title: '入退出検出（In/Out Zone）',
        desc: '出入口ゾーンでの入退を自動検出し、出入り履歴や滞在時間の分析をサポートします。',
      },
      {
        img: Icon3d3d,
        title: '機器検索と状態管理',
        desc: '複数のタグやアンカー機器を検索し、バッテリーや接続状態を一目で確認・管理できます。',
      },
    ],
  },
};
